import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { Link } from '@calendly/ui/components/link'
import { CalendlyLogo } from '@calendly/ui/components/wordmark-logo'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { BodyText } from '@calendly/ui/components/typography'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'

import { useI18n } from 'locales'
import { eventTypeSelector } from 'root-api'
import { isEmbeddedSelector } from 'selectors/embed'
import { useProfile } from 'components/use_profile'
import { useRoutingForm } from 'components/use_routing_form'
import _Outer from "booking_redesign_legal_footer-Outer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=Outer";
import _GridRow from "booking_redesign_legal_footer-GridRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=GridRow";
import _LogoWrap from "booking_redesign_legal_footer-LogoWrap.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=LogoWrap";
import _SizingCalendlyLogo from "booking_redesign_legal_footer-SizingCalendlyLogo.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=SizingCalendlyLogo";
import _RightLinks from "booking_redesign_legal_footer-RightLinks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=RightLinks";
import _CookieButton from "booking_redesign_legal_footer-CookieButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=CookieButton";


const checkIfIframe = () => window.location !== window.parent.location

const Outer = /*#__PURE__*/styled('div', null, {
  displayName: "Outer",
  styles: _Outer
})

const GridRow = /*#__PURE__*/styled('div', null, {
  displayName: "GridRow",
  styles: _GridRow
})

const LogoWrap = /*#__PURE__*/styled('div', null, {
  displayName: "LogoWrap",
  styles: _LogoWrap
})

const SizingCalendlyLogo = /*#__PURE__*/styled(CalendlyLogo, null, {
  displayName: "SizingCalendlyLogo",
  styles: _SizingCalendlyLogo
})

const RightLinks = /*#__PURE__*/styled('div', null, {
  displayName: "RightLinks",
  styles: _RightLinks
})

const CookieButton = /*#__PURE__*/styled(MinimalButton, null, {
  displayName: "CookieButton",
  styles: _CookieButton
})

export const BookingRedesignLegalFooter = ({ className }) => {
  const { i18n } = useI18n()
  const embedFromStore = useSelector(isEmbeddedSelector)
  const isEmbedded = checkIfIframe() || embedFromStore
  const eventType = useSelector(eventTypeSelector)
  const profile = useProfile()
  const routingForm = useRoutingForm()
  const hideCalendlyLogo = Boolean(
    eventType?.unbranded || profile?.unbranded || routingForm?.organization?.unbranded
  )

  return (
    <Outer className={className}>
      <GridRow
        style={
          hideCalendlyLogo
            ? { gridTemplateColumns: 'minmax(0, 1fr)' }
            : { gridTemplateColumns: 'auto minmax(0, 1fr)' }
        }
      >
        {!hideCalendlyLogo && (
          <LogoWrap>
            <SizingCalendlyLogo alt="Calendly" color={colorTextSecondary} />
          </LogoWrap>
        )}
        <RightLinks>
          <CookieButton onClick={() => window.OneTrust?.ToggleInfoDisplay()}>
            <BodyText as="span" inline size="medium" color={colorTextSecondary}>
              {i18n.t('booking.terms_and_conditions.manage_cookies')}
            </BodyText>
          </CookieButton>
          {!isEmbedded && (
            <Link
              underline={false}
              href="https://calendly.com/legal/privacy-notice"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BodyText as="span" inline size="medium" color={colorTextSecondary}>
                {i18n.t('booking.terms_and_conditions.privacy_policy')}
              </BodyText>
            </Link>
          )}
        </RightLinks>
      </GridRow>
    </Outer>
  )
}
